/** @file frameEvent: the name of the window event that asks the viewport to frame the selection. */

/** `pose3d:frame-selection` (detail: `{ node }`); the node tree dispatches it, the viewport answers with its frame action. */
export const frameEvent = 'pose3d:frame-selection';
